import { Theme } from '@material-ui/core';
import ClassName from 'app/styles/ClassName';
import styledFuncs from 'app/styles/styledFuncs';
import React from 'react';
import styled, { css } from 'styled-components/macro';
import { useViewport } from '../context-hooks/use-viewport.hook';

const getSizeCalc =
  (mode: 'width' | 'height') => (p: { theme: Theme } & TileProps) => {
    const vWidth = `${p.$vWidth}px`;
    const padding = styledFuncs.pad(2)(p);
    const widthFraction = p.$wide && mode === 'width' ? 1 : 0.5;

    return `calc((${vWidth} - ${padding}) * ${widthFraction})`;
  };

type TileProps = {
  $wide?: boolean;
  $vWidth: number;
  $maxHeight?: number;
};
const StyledTile = styled.div<TileProps>`
  position: relative;
  width: ${getSizeCalc('width')};
  height: auto;
  ${p =>
    p.$maxHeight &&
    css`
      max-height: ${p.$maxHeight}px;
    `}
  padding: ${styledFuncs.pad()};
`;

type Props = {
  wide?: boolean;
  maxHeight?: number;
  className?: string;
  children?: React.ReactNode;
};
export default function AdoptiveTile({
  wide,
  maxHeight,
  ...props
}: Props): JSX.Element {
  const { vWidth } = useViewport();
  return (
    <StyledTile
      $wide={wide}
      $vWidth={vWidth}
      $maxHeight={maxHeight}
      {...props}
    />
  );
}

export const TileContainer = styled.div.attrs({
  className: ClassName.NO_AUTO_MARGIN,
})`
  display: flex;
  flex-flow: row wrap;
  width: 100%;
`;
